import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { NavBar } from 'components/NavBar'
import { Drawer } from 'components/Drawer'
import { UserContext } from 'contexts'

import { useStyles } from './styles'

const Layout: React.FC = ({ children }) => {
  const classes = useStyles()
  const { admin } = useContext(UserContext)

  if (!admin) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className={classes.root}>
      <NavBar isLoggedIn />
      <Drawer />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  )
}

export { Layout }
